import * as idEndpoints from './id';
import { root, id } from './user-invites';

export const userInvites = {
  ...root,
  id: {
    ...id,
    ...idEndpoints,
  },
};
